// Default method
var GetChildrenSizers = function(out) {
    if (out === undefined) {
        out = [];
    }
    return out;
}
export default GetChildrenSizers;